import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { BankIcon, ErrorRed } from '../../../../assets/icons'
import { Spacer } from '../../../../ui/atoms'
import SubmitButton from '../../../Auth/SubmitButton'
import { PaymentStatusModal } from './PaymentStatusModal'

interface PayWithBankAccountFlow_ERRORProps {
  title: string
  subtitle: string
  paymentMethodSubtitle: string
  paymentMethodName: string
  onClose: () => void
  onContinue: () => void
}

export const PayWithBankAccountFlow_ERROR: React.FC<PayWithBankAccountFlow_ERRORProps> =
  memo(
    ({
      title,
      subtitle,
      paymentMethodSubtitle,
      onClose,
      onContinue,
      paymentMethodName,
    }) => {
      const { t } = useTranslation('global')

      return (
        <PaymentStatusModal
          headerIcon={<ErrorRed style={{ alignSelf: 'center' }} />}
          footer={
            <>
              <SubmitButton
                testID={'payment-failed-submit-btn'}
                style={{ backgroundColor: '#00A0F3' }}
                onPress={onContinue}
              >
                {t('TabInvoice.go_back_and_try_again')}
              </SubmitButton>
              <Spacer height={20} />
            </>
          }
          // eslint-disable-next-line i18next/no-literal-string
          backgroundColor={'#f5ebec'}
          title={title}
          subtitle={subtitle}
          paymentMethodSubtitle={paymentMethodSubtitle}
          paymentMethodName={paymentMethodName}
          paymentMethodIcon={<BankIcon />}
          onClose={onClose}
        />
      )
    },
  )
